import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IrrelevantPODAccess from "./IrrelevantPODAccess";
import KIOSKReport from "./KIOSKReport";
import KIOSKAccessInmateReport from "./KIOSKAccessInmateReport";
import SharedPOD from "./SharedPOD";
import InmateAccessableMenus from "./InmateAccessableMenus";
import {
  logReportAction,
  masterActions,
  publicUserActions,
} from "../../_store";
import dragicon from "../../assets/svg/click-and-drag.svg";

const LogReportDetails = () => {
  const dispatch = useDispatch();
  const { islogReporttabKey } = useSelector((state) => state.master);
  const { LogReportsCurrrentTab: activeTab } = useSelector((x) => x.publicUser);
  // const [activeTab, setActiveTab] = useState("logreport-kiosk-tab");

  const [tabKey, setTabKey] = useState(islogReporttabKey ? islogReporttabKey : 0); // Key to force refresh
  // }, [activeTab])

  useEffect(() => {
    setTabKey(islogReporttabKey ? islogReporttabKey : 0);
  }, [islogReporttabKey]);

  const handleTabClick = (tabId) => {
    if (activeTab !== tabId) {
      // setLogReportsCurrrentTab(tabId);
      dispatch(publicUserActions.setLogReportsCurrrentTab(tabId));
      setTabKey((prevKey) => prevKey + 1); // Change key to force re-render

      if (tabId === "logreport-inmate-access") {
        dispatch(logReportAction.clearInmateMenu());
        dispatch(masterActions.clearinmateAccessMenuList());
      }
    }
  };

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100 mb-4 ">
      <div className="overflow-auto">
        <ul
          className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
          style={{ whiteSpace: "nowrap" }}
        >
          <li className="nav-item flex-shrink-0">
            <a
              href="#logreport-kiosk-tab"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "logreport-kiosk-tab" ? "active" : "text-black"
                }`}
              onClick={() => handleTabClick("logreport-kiosk-tab")}
            >
              <span className="font-size-15">Kiosk Reports</span>
            </a>
          </li>
          <li className="nav-item flex-shrink-0">
            <a
              href="#logreport-irrelevant-access"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "logreport-irrelevant-access"
                ? "active"
                : "text-black"
                }`}
              onClick={() => handleTabClick("logreport-irrelevant-access")}
            >
              <span className="font-size-15">Irrelevant Pod Access</span>
            </a>
          </li>
          <li className="nav-item flex-shrink-0">
            <a
              href="#logreport-inmate-access"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "logreport-inmate-access"
                ? "active"
                : "text-black"
                }`}
              onClick={() => handleTabClick("logreport-inmate-access")}
            >
              <span className="font-size-15">Inmate Accessible Menus</span>
            </a>
          </li>
          <li className="nav-item flex-shrink-0">
            <a
              href="#logreport-sharepod-access"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "logreport-sharepod-access"
                ? "active"
                : "text-black"
                }`}
              onClick={() => handleTabClick("logreport-sharepod-access")}
            >
              <span className="font-size-15">
                Shared Pod Access Inmate Reports
              </span>
            </a>
          </li>
          <li className="nav-item flex-shrink-0">
            <a
              href="#logreport-kisok-access-inmate-report"
              data-bs-toggle="tab"
              className={`nav-link ${activeTab === "logreport-kisok-access-inmate-report"
                ? "active"
                : "text-black"
                }`}
              onClick={() =>
                handleTabClick("logreport-kisok-access-inmate-report")
              }
            >
              <span className="font-size-15">
                Any Kiosk Access Inmate Reports
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div className="dragicon-container">
        <img
          src={dragicon}
          alt="pending-status"
          title="Pending"
          className="dragicon"
        />
      </div>
      <div className="tab-content panel rounded-0 m-0">
        <div
          className={`tab-pane fade ${activeTab === "logreport-kiosk-tab" ? "active show" : "text-black"
            }`}
          id="logreport-kiosk-tab"
        >
          {activeTab === "logreport-kiosk-tab" && <KIOSKReport key={tabKey} />}
        </div>
        {activeTab === "logreport-irrelevant-access" && (
          <IrrelevantPODAccess key={tabKey} />
        )}
        <div
          className={`tab-pane fade ${activeTab === "logreport-inmate-access"
            ? "active show"
            : "text-black"
            }`}
          id="logreport-inmate-access"
        >
          {activeTab === "logreport-inmate-access" && (
            <InmateAccessableMenus key={tabKey} />
          )}
        </div>
        {activeTab === "logreport-sharepod-access" && (
          <SharedPOD key={tabKey} />
        )}
        {activeTab === "logreport-kisok-access-inmate-report" && (
          <KIOSKAccessInmateReport key={tabKey} />
        )}
      </div>
    </div>
  );
};

export default React.memo(LogReportDetails);
